import { defaultDb } from 'src/contexts/FirebaseContext';

export const serverTime = (db = false) => {
  if (db) return defaultDb.database.ServerValue.TIMESTAMP;
  return defaultDb.firestore.Timestamp.now();
};
